module.exports = __webpack_public_path__ + "img/right_yezi.d830dbb6.svg";